import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  NoticeCreatedAt,
  NoticeData,
  NoticeEntityId,
  NoticeKind
} from "../interface";
import {
  noticeCreatedAt,
  noticeData,
  noticeEntityId,
  noticeKind
} from "../schema";

export class NoticeEntity {
  private static configValidation = JsonSchemaValidator.compile(
    NoticeEntity.configValidationSchema()
  );

  readonly value: Notice;

  constructor(value: Notice) {
    this.value = JsonSchemaValidator.assert(
      NoticeEntity.configValidation,
      value
    );
  }

  toJSON() {
    return this.value;
  }

  private static configValidationSchema() {
    return {
      type: "object",
      required: ["id", "kind", "data", "createdAt"],
      properties: {
        id: noticeEntityId,
        kind: noticeKind,
        data: noticeData,
        createdAt: noticeCreatedAt
      },
      additionalProperties: false
    };
  }
}

export interface NoticeEntityJson extends Notice {}

interface Notice {
  id: NoticeEntityId;
  kind: NoticeKind;
  data: NoticeData;
  createdAt: NoticeCreatedAt;
}
